























































































































import { Component, Vue } from "vue-property-decorator";
import { State, namespace } from "vuex-class";
import TPPClaimsModule from "@/store/modules/tpp-claims";
import { TPPClaimsState } from "@/models/store/TPPClaimsState";
import { formatDate } from "@/helpers/functions/format-date";

const tppClaims = namespace(TPPClaimsModule.name);

@Component({
  name: "AdditionalInfo"
})
export default class AdditionalInfo extends Vue {
  // ===== Props ===== //

  // ===== Store ===== //
  @State("tppClaims") private readonly tppClaims!: TPPClaimsState;
  @tppClaims.Action("handlePropertyManagerNotified") public handlePropertyManagerNotified!: (payload: boolean) => void;
  @tppClaims.Action("handleDiscoveredLoss") public handleDiscoveredLoss!: (payload: string) => void;
  @tppClaims.Action("handleCurrentLocationDamagedItems") public handleCurrentLocationDamagedItems!: (payload: string) => void;
  @tppClaims.Action("handleFiledOtherClaim") public handleFiledOtherClaim!: (payload: boolean) => void;
  @tppClaims.Action("handleFiledOtherClaimLossType") public handleFiledOtherClaimLossType!: (payload: string) => void;
  @tppClaims.Action("handleFiledOtherClaimDate") public handleFiledOtherClaimDate!: (payload: string) => void;

  // ===== Data ===== //

  // ===== Methods ===== //

  // ===== Computed ===== //
  get lossTypes() {
    return this.tppClaims.lossTypesList;
  }

  get selectedTPPClaim() {
    return this.tppClaims.selectedTPPClaim;
  }

  get propertyManagerNotified() {
    return this.selectedTPPClaim!.info_manager_notified;
  }
  set propertyManagerNotified(newVal: boolean) {
    this.handlePropertyManagerNotified(newVal);
  }

  get discoveredLoss() {
    return this.selectedTPPClaim!.damage_discovered_by;
  }
  set discoveredLoss(newVal: string) {
    this.handleDiscoveredLoss(newVal);
  }

  get currentLocationDamagedItems() {
    return this.selectedTPPClaim!.items_current_location;
  }
  set currentLocationDamagedItems(newVal: string) {
    this.handleCurrentLocationDamagedItems(newVal);
  }

  get filedOtherClaim() {
    return this.selectedTPPClaim!.another_claim_filed;
  }
  set filedOtherClaim(newVal: boolean) {
    this.handleFiledOtherClaim(newVal);
  }

  get filedOtherClaimLossType(): string {
    return this.selectedTPPClaim!.another_claim_loss_type && this.selectedTPPClaim!.another_claim_loss_type.alias
      ? this.selectedTPPClaim!.another_claim_loss_type.alias : "";
  }
  set filedOtherClaimLossType(newVal: string) {
    this.handleFiledOtherClaimLossType(newVal);
  }

  get filedOtherClaimDate() {
    return this.selectedTPPClaim!.another_claim_date ? formatDate(this.selectedTPPClaim!.another_claim_date) : "";
  }
  set filedOtherClaimDate(newVal: string) {
    this.handleFiledOtherClaimDate(newVal);
  }

  // ===== Lifecycle ===== //
}
